export default {
    title:{
        default: 'Redeem History'
    },
    view_code: 'ดูโค้ด',
    view_slip: 'ดูสลิป',
}
